import { fromJS } from 'immutable';
import {
  FETCH_CASE,
  FETCH_CASE_FAILED,
  FETCH_CASE_SUCCESS,
  GET_PORTAL_CASE,
  GET_PORTAL_CASE_FAILED,
  GET_PORTAL_CASE_SUCCESS
} from './actions';
import { CASE_DETAIL_KEY, RESUME_CASE_KEY } from '../../utils/constants';
import * as analytics from '../../utils/analytics';

export const initialState = fromJS({
  loading: false
});

const caseReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CASE:
      return state.set('loading', action.meta.loading);
    case FETCH_CASE_FAILED:
      return state.set('loading', false).set('error', action.error);
    case FETCH_CASE_SUCCESS:
      updateAnalytics(action);
      return state.set('loading', false).set(CASE_DETAIL_KEY, fromJS(action.payload));
    case GET_PORTAL_CASE:
      return state.set('loading', true);
    case GET_PORTAL_CASE_FAILED:
      return state.set('loading', false).set('error', action.error);
    case GET_PORTAL_CASE_SUCCESS:
      return state.set('loading', false).set(RESUME_CASE_KEY, fromJS(action.payload));
    default:
      return state;
  }
};

const updateAnalytics = action => {
  analytics.updateCase(action.payload);
  analytics.updateApplicant();
  if (action.payload && action.payload.applicant && action.payload.applicant.joint_link_code) {
    analytics.updateApplicant(action.payload.applicant.joint_link_code);
  }
  if (action.payload && action.payload.product && action.payload.product.variant) {
    analytics.updateBusinessType(action.payload.product.variant);
  }
};

export default caseReducer;
